import { all, fork } from 'redux-saga/effects';

import watchSendContact from './sendContact';
import watchSendNewsletter from './sendNewsletter';

function* contactSagas() {
  yield all([fork(watchSendContact), fork(watchSendNewsletter)]);
}

export default contactSagas;
